import React, { useState, useEffect } from "react";
import { importService } from "../../../Services/import.service";
import { Modal, Button } from "react-bootstrap";

export default function ImportDetailModal(props) {
  const [show, setShow] = useState(props.show);
  const [data, setData] = useState([]);

  const handleClose = () => props.handleClose();
  const onOk = () => props.handleClose();

  useEffect(() => {
    setShow(props.show);

    if (props.scheduleFileIdDetail) {

      try {
        importService.fetchDetail(props.scheduleFileIdDetail).then((details) => {
          if (details) {
            setData(details);
          }
        });
      } catch (error) {
        console.log("Erro ao buscar detalhes da importação");
        console.log(error);
      }
    }

  }, [props]);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Detalhes da importação</Modal.Title>
        </Modal.Header>
        <Modal.Body >

          {data ? (
            data.map((item, index) => (
              <>

                <h5 key={index}>{item.statusDescription}</h5>
              </>
            ))) : (<></>)}


        </Modal.Body>
        <Modal.Footer>
          <Button variant='warning' onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant='primary'
            onClick={onOk}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
